<template>
  <div class="section-two" v-if="detail">
    <div class="detail">
      <p class="title">{{detail.name}}</p>
      <div class="count-down-wrap" v-if="detail.can_apply">
        <div class="start-wrap" v-if="start_count_down">
          <i class="el-icon-time"></i>
          <span>距离报名开始时间：{{start_count_down}}</span>
        </div>
        <div class="end-wrap" v-if="end_count_down">
          <i class="el-icon-time"></i>
          <span>距离报名结束时间：<span class="time">{{end_count_down}}</span></span>
        </div>
      </div>
      <div class="date-info">
        <span style="margin-left: 20px;">发布者：{{detail.publisher}}</span><span
          style="margin-left: 20px;">发布时间：{{detail.publish_date}}</span><span
          style="margin-left: 20px;">浏览量：{{detail.num_read}}</span>
      </div>
      <div class="htm" v-html="detail.content"></div>
      <div class="file-wrap" v-if="detail.attach_files">
        <h3 >附件下载：</h3>
        <a :href="file.xurl" :download="file.name" target="_blank"  v-for="(file,index) in detail.attach_file_list" :key="index">
          <div class="file-item">
            {{file.name}} <i class="el-icon-download" style="font-weight: bold;color: #333;"></i>
          </div>
        </a>
      </div>
      <div class="btn-wrap" v-if="detail.can_apply">
        <a href="http://admin.gdslzb.cn/admin/login" target="_blank">
          <el-button type="primary" style="width: 180px;">
            我要报名
          </el-button>
        </a>
      </div>
    </div>
    <div class="prev-next">
      <p><span>上一篇: </span>
        <a v-if="prev.id" href="javascript:;" @click="handleClick(prev.id)">{{prev.name}}</a>
        <span v-else>无</span>
      </p>
      <p><span>下一篇: </span>
        <a v-if="next.id" href="javascript:;" @click="handleClick(next.id)">{{next.name}}</a>
        <span v-else>无</span>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "conDetail",
    props: {
      detail: {
        type: Object,
        default: function() {
          return {can_apply:false}
        }
      },
      prev: {
        type: Object,
        default: function() {
          return {}
        }
      },
      next: {
        type: Object,
        default: function() {
          return {}
        }
      },
      apply: {
        type: Boolean,
        default: false
      }

    },
    data() {
      return {
        leftTime: 0,
        start_count_down:'',
        end_count_down:''
      };
    },
    created() {
    },
    watch:{
      detail(val){
        if(val && this.apply){
          var curr_time = new Date().getTime() * 0.001
          var start_time = val.apply_start_time
          var end_time = val.apply_end_time
          start_time = new Date(start_time).getTime() * 0.001
          end_time = new Date(end_time).getTime() * 0.001
          
          if(start_time > curr_time){
            //开始倒计时
            this.leftTime = parseInt(start_time - curr_time)
            this.startCountDown()
          }
          if(start_time< curr_time && end_time > curr_time){
            this.leftTime = parseInt(end_time - curr_time)
            this.endCountDown()
          }
          
        }
      }
    },
    methods: {
      
      
      //开始倒计时
      startCountDown(){
        let that = this
        let leftTime = this.leftTime
        if(leftTime == 0){
          this.detail.can_apply = true
          this.start_count_down = ''
          var curr_time = new Date().getTime() * 0.001
          var end_time = this.detail.apply_end_time
          end_time = new Date(end_time).getTime() * 0.001
          this.leftTime = parseInt(end_time - curr_time)
          this.endCountDown()
          return
        }
        let day = parseInt(leftTime / 86400)
        let hour = parseInt((leftTime % 86400) / 3600)
        let minute = parseInt((leftTime % 3600) / 60)
        let second = parseInt((leftTime % 60))
        let str = day + '天' + hour + '时' + minute + '分' + second + '秒'
        this.start_count_down = str
        setTimeout(function(){
          that.leftTime --
          that.startCountDown()
        },1000)
      },
      //报名结束倒计时
      endCountDown(){
        let that = this
        let leftTime = this.leftTime
        if(leftTime == 0){
          this.detail.can_apply = false
          this.end_count_down = ''
          return
        }
        let day = parseInt(leftTime / 86400)
        let hour = parseInt((leftTime % 86400) / 3600)
        let minute = parseInt((leftTime % 3600) / 60)
        let second = parseInt((leftTime % 60))
        let str = day + '天' + hour + '时' + minute + '分' + second + '秒'
        this.end_count_down = str
        setTimeout(function(){
          that.leftTime --
          that.endCountDown()
        },1000)
      },
      handleClick(id) {
        this.$emit('showDetail', id)
      },
      download(item) { //下载文件
        console.log(item)
        let a = document.createElement('a')
        let url = item.xurl
        fetch(url, {
          mode: 'no-cors'
        }).then(res => res.blob()).then(blob => {
          a.href = URL.createObjectURL(blob)
          a.download = item.name
          a.click()
        })
      }
    }
  }
</script>

<style scoped>
  .detail .htm{
    padding: 20px;
    min-height: 500px;
    overflow: hidden;
  }
  .count-down-wrap{
    height: 80px;
  }
  .count-down-wrap .start-wrap{
    background-color: #ff4e4e;
    position: absolute;
    padding: 10px 20px;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    right: -10px;
    color: #fff;
  }
  .count-down-wrap .start-wrap::after{
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    right: 0px;
    bottom: -5px;
    transform: rotate(90deg);
    border-left:5px solid transparent;
    border-right:5px solid transparent;
    border-bottom:10px solid #ff4e4e;
  }
  .count-down-wrap .start-wrap i{
    font-size: 18px;
  }
  .count-down-wrap .start-wrap span{
    font-size: 18px;
    margin-left: 6px;
  }
  .count-down-wrap .end-wrap{
    position: absolute;
    right: 30px;
    margin-top: 20px;
  }
  .count-down-wrap .end-wrap i{
    font-size: 16px;
  }
  .count-down-wrap .end-wrap span{
    font-size: 16px;
    margin-left: 6px;
  }
   .count-down-wrap .end-wrap span .time{
     color: #ff4e4e;
   }
  .section-two {
    padding: 30px;
    min-height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .section-two .detail .title {
    font-size: 24px;
    text-align: center;
    color: #333;
    font-weight: bold;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .section-two .detail .date-info {
    color: #999;
    text-align: center;
    margin-bottom: 0px;
  }

  a:hover {
    color: #0080FF;
  }

  .section-two .prev-next {
    margin-top: 30px;
  }

  .section-two .prev-next p {
    margin: 10px 0;
  }

  .file-wrap {
    margin-top: 40px;
  }

  .file-wrap h3 {
    font-size: 16px;
    font-weight: bold;
  }

  .file-wrap .file-item {
    margin-top: 6px;
    font-size: 16px;
    color: #0080FF;
    cursor: pointer;
  }
  
  .btn-wrap{
    width: 100%;
    padding: 40px;
    margin: 0 auto;
    box-sizing: border-box;
    text-align: center;
  }
</style>
<style>
  p img{max-width: 100% !important; max-height:auto !important;}
</style>